import { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { Layout } from '@/components'
import { PageLoader } from '@/components/AuthShell'
import {
  HomePage,
  KnowledgeAssetsPage,
  DevPage,
  SettingsPage,
  LoginPage,
  OidcCallbackPage,
} from '@/pages'
import { useAppStore } from '@/store/appStore'

const RFPDetailPage = lazy(() => import('@/pages/RFPDetailPage'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

function App() {
  const isAuthenticated = useAppStore((state) => state.user.isAuthenticated)
  const devMode = useAppStore((state) => state.devMode)

  const protectedApp = (
    <Layout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rfp/:rfp_id" element={<RFPDetailPage />} />
          <Route path="/assets" element={<KnowledgeAssetsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/dev" element={devMode ? <DevPage /> : <Navigate to="/" replace />} />
          <Route path="/auth/callback" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Layout>
  )

  const authApp = (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<OidcCallbackPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  )

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {isAuthenticated ? protectedApp : authApp}
      </Router>
    </QueryClientProvider>
  )
}

export default App
